"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownButton = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var TrailingButton_1 = __importDefault(require("../components/Drawer/ControlPanel/widgets/TrailingButton"));
var dropdown_icon_white_svg_1 = __importDefault(require("../assets/dropdown-icon-white.svg"));
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        textDiv: {
            paddingLeft: 20,
        },
        icon: {
            paddingRight: 20,
        },
        menuPaper: {
            marginTop: 6,
            marginBottom: 6,
            boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)',
        },
        menuText: {
            fontWeight: 500,
            paddingLeft: 30,
            paddingRight: 30,
        },
        menuItemRoot: {
            minWidth: 135,
            height: 48,
        },
    });
});
function DropdownButton(_a) {
    var variant = _a.variant, className = _a.className, buttonText = _a.buttonText, options = _a.options, fullWidth = _a.fullWidth;
    var classes = useStyles();
    var _b = __read(react_1.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TrailingButton_1.default, { className: className, variant: variant || 'outlined', onClick: handleClick, fullWidth: fullWidth },
            react_1.default.createElement("div", { className: classes.textDiv }, buttonText),
            react_1.default.createElement("img", { className: classes.icon, src: dropdown_icon_white_svg_1.default, alt: "Download", draggable: false })),
        react_1.default.createElement(core_1.Menu, { classes: {
                paper: classes.menuPaper,
            }, MenuListProps: { style: { padding: '5 0', height: '100%' } }, anchorEl: anchorEl, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose }, options.map(function (option) {
            return (react_1.default.createElement(core_1.MenuItem, { classes: {
                    root: classes.menuItemRoot,
                }, key: option.name, onClick: function (event) {
                    option.onClick(event);
                    handleClose();
                }, disableGutters: true },
                react_1.default.createElement(core_1.Typography, { className: classes.menuText, variant: "body2", color: "primary" }, option.name)));
        }))));
}
exports.DropdownButton = DropdownButton;
